import { Component } from '@angular/core';

@Component({
  selector: 'app-blocked-modal',
  standalone: true,
  imports: [],
  templateUrl: './blocked-modal.component.html',
  styleUrl: './blocked-modal.component.css'
})
export class BlockedModalComponent {

}
